export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'HOME': 'Home',
            'CATEGORIAS': 'Categories',
            'EMISSAO': 'Emission',
            'VOUCHERS' : 'Vouchers',
            'RH' : 'Human Resources',
            'DEPARAPROMOTOR' : 'In / For Promoter',
            'FUNCIONARIOS' : 'Employees',
            'CADASTRO'  :   'Register',
            'CAMBIO': 'Exchange',
            'CUPOM': 'Coupon'
        }
    }
};
